import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from '../store/root.state';
import * as spinnerActions from '../store/session/spinner/spinner.actions';
import * as userActions from '../store/user/user.actions';
import { catchError, delay, EMPTY, Observable, retry, retryWhen, Subject, switchMap, tap, throwError, timeout, of } from 'rxjs';
import { LocalStorageService } from './local-storage.service';
import { Router } from '@angular/router';
import { LoginService } from '../features/login/login.service';
import { RefreshToken } from '../model/request/auth';
import { Token } from '../model/request/token';
import { TokenR } from '../model/response/token-r';
import { UserDataStringResponse } from '../model/response/user/user';
import { environment } from 'src/environments/environment';
import { ToastService } from '../core/toast/toast.service';

@Injectable()
export class ErrorInterceptorV2 implements HttpInterceptor {

  private isRefreshing: boolean = false;
  private tokenRefreshSubject$: Subject<number> = new Subject<number>();

  private httpRequestMaker$: Subject<void> = new Subject<void>();
  private retries: number = 0;
  private maxRetry: number = 4;
  private delayTime: number = 2000;

  constructor(private localStorageService: LocalStorageService,
    private store: Store<AppState>,
    private userService: LoginService,
    private route: Router,
    private toastService: ToastService,
  ) {

    this.httpRequestMaker$.subscribe(() => {
      console.log("STARTING HTTP REQUEST")
    });


    this.tokenRefreshSubject$.subscribe((d:number) => {
      /* this.userService.getUserDatastring(d).subscribe({
        next: (risp: UserDataStringResponse) => {
          //make this shit work
          if(risp.response.success != false) {
            this.store.dispatch(new userActions.Login({
              userId: risp.user.userId,
              username: risp.user.username,
              roles: risp.user.roles,
              rolesId: risp.user.rolesId,
              filiali: risp.user.filiali,
              password: risp.user.password,
              creationDate: risp.user.creationDate,
              email: risp.user.email,
              surname: risp.user.surname,
              active: risp.user.active,
              authorized: risp.user.authorized,
              checking: false,
              neverLogged: false,
            }));
          }

        },
        error: (e:any) => {
          console.log("\n cant update user data \n");
        }
      }); */
    });
  }


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(response => {
        console.log(JSON.stringify(response));
        this.store.dispatch(new spinnerActions.SpinnerHidden({ senderID: '', requestID: request.method, visible: false }));
      }),
      catchError((err: HttpErrorResponse) => {
        console.error(err);

        let session = this.localStorageService.getSession();
        //console.log("🚀 ~ file: error-interceptorv2.interceptor.ts:96 ~ ErrorInterceptorInterceptor ~ catchError ~ session:", session)
        //console.log("🚀 ~ file: error-interceptorv2.interceptor.ts:98 ~ ErrorInterceptorInterceptor ~ catchError ~ err.status:", err.status)
        //console.log("🚀 ~ file: error-interceptorv2.interceptor.ts:102 ~ ErrorInterceptorInterceptor ~ catchError ~ this.isRefreshing:", this.isRefreshing)

        if (request.url.includes('refresh-token') && err.status == 400) {
          this.isRefreshing = false;
          console.error("Error while updating the token, refresh the page");
          localStorage.clear();
          this.route.navigate(['/auth/login', { tokenExpired: true }]);
          return throwError(() => new Error("Token refresh failed"));
        }

        if (err.status == 401) {
          if (this.isRefreshing == false && session != null) {
            this.isRefreshing = true;
            console.log(" \n \n \n \n \n Token expired, now refreshing... \n \n \n \n \n");

            let data: RefreshToken = {
              userId: session.id,
              refreshToken: session.refreshToken
            };




            return this.userService.refreshToken(data).pipe(
              switchMap((response: TokenR) => {
                if (!response.success.success) {
                  this.isRefreshing = false;
                  console.error("\n \n Error while updating the token, refresh the page \n \n");
                  
                  return throwError(() => new Error("Token refresh failed"));
                }

                //console.warn("###############################################################################")
                this.localStorageService.saveRefreshedToken(response);

                this.tokenRefreshSubject$.next(data.userId);


                const clonedRequest = request.clone({
                  setHeaders: { Authorization: `Bearer ${response.token}` }
                });



                this.isRefreshing = false;
                this.httpRequestMaker$.next();
                return next.handle(clonedRequest);
              }),
              catchError((error) => {
                return throwError(() => error);
              })
            );
          } else if (session == null && this.isRefreshing == false) {
            //console.warn(session);
            console.error('Invalid session');
            session = this.localStorageService.getSession();
            console.warn(session);
            if (session == null) {
              localStorage.clear();
              this.route.navigate(['/auth/login']);
            }
          } else {
            if (this.retries <= this.maxRetry) {
              return this.httpRequestMaker$.pipe(
                switchMap(() => next.handle(this.addTokenHeader(request)))
              );
            } else {
              let errRisp: HttpErrorResponse = err.error;
              console.log(JSON.stringify(errRisp));
              return throwError(() => errRisp);
            }
          }
        } else {
          if (this.isRefreshing == false) {
            let errRisp: HttpErrorResponse = err.error;
            console.log(JSON.stringify(errRisp));
            return throwError(() => errRisp);
          }
        }
        return EMPTY;
      })
    );
  }

  private addTokenHeader(request: HttpRequest<any>) {
    return request.clone({
      headers: request.headers.set('Authorization', 'Bearer ' + this.localStorageService.getSession()?.token),
    });
  }
}

export const ErrorInterceptorProvider = { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorV2, multi: true };
